import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import IncentiveClaimForm from "../../components/User/IncentiveClaimForm";

const IncentiveClaimApplication = () => {
  const { language, setLanguage } = useLanguage();
  return (
    <DashboardLayout pageTitle={language ? "आवेदन फार्म" : "Application Form"}>
      <IncentiveClaimForm />
    </DashboardLayout>
  );
};

export default IncentiveClaimApplication;
